import EventEmitter from 'src/helpers/EventEmitter'

const url = 'wss://api.panstone.group:9999/client/invSocket/'
const RECONNECT_TIMEOUT = 3000
const MAX_RECONNECT_TIME = 8

const Events = {
  ONMESSAGE: 0,
  ONOPEN: 200,
  ONERROR: 400,
  QR_SCANNED: 1001,
  QR_CONFIRMED: 1002,
  QR_REJECTED: 1003,
  QR_EXPIRED: 1004,
  QR_CLOSED: 1005,
}

class SocketService {
  constructor() {
    Object.assign(this, EventEmitter)
    if (!SocketService._instance) {
      SocketService._instance = this
      this._connected = false
      this._attempts = 0
      console.log('socket init')
    }
    return SocketService._instance
  }

  connect(userId) {
    console.log('socket connect', userId)
    if (this._socket && this._socket.readyState === WebSocket.OPEN) {
      console.log('connected')
      this._connected = true
      return
    }
    this.userId = userId
    this.keepAlive = true
    let socket = new WebSocket(url + userId)

    console.log(socket)

    // setup event handler
    socket.onopen = (e) => {
      this._connected = true
      this._attempts = 0
      this.cancelReconnect()
      console.log('socket open', e, e.data)
    }
    socket.onmessage = (msg) => {
      this._onMessage(msg)
    }
    socket.onclose = (e) => {
      console.log('socket closed')
      this._connected = false
      if (this.keepAlive) {
        this.reconnect()
      } else {
        this._socket = null
      }
    }
    socket.onerror = (e) => {
      console.log('socket error', e)
      this._connected = false
      if (this.keepAlive) {
        this.reconnect()
      }
    }
    this._socket = socket

    //this.reconnect()
  }

  reconnect() {
    console.log('reconnect')
    if (this._reconnectTime > MAX_RECONNECT_TIME) {
      console.log('socket failed, stop trying')
      this._onError()
    } else {
      clearTimeout(this._reconnectTimer)
      this._reconnectTimer = setTimeout(() => {
        console.log(
          'connection failed, try reconnecting, this is the ' +
            this._attempts +
            ' time'
        )
        this._socket.close()
        this._attempts++
        this.connect(this.userId)
      }, RECONNECT_TIMEOUT)
    }
  }

  cancelReconnect() {
    clearTimeout(this._reconnectTimer)
  }

  // 前端主动close socket
  close() {
    this.keepAlive = false
    this._socket.close()
    //this._reconnectTime = 0
  }

  send(evt, data = {}) {
    if (this._connected && this._socket) {
      console.log('emit', evt)
      let msgObj = {
        msg: '',
        code: evt,
        data: data,
      }
      let json = JSON.stringify(msgObj)
      this._socket.send(json)
    } else {
      console.log('socket not connected, try connect...')
      this.connect(this.userId)
    }
  }
  _onMessage = (e) => {
    //window.alert('msg rec:' + JSON.stringify(e))
    console.log('msg rec:' + e)
    this.emit(Events.ONMESSAGE, JSON.parse(e.data))
  }

  _onError = (e) => {
    this.close()
    this.emit(Events.ONERROR)
  }

  getSocket() {
    return this._socket
  }

  getInstance() {
    return SocketService._instance
  }
}

const service = new SocketService()
service.Events = Events
export default service
